import type { JSX, JSXElementConstructor } from 'react';

export type Direction = 'row' | 'column' | 'row-reverse' | 'column-reverse';
export type Align = 'start' | 'center' | 'end';
export type Justify =
	| 'start'
	| 'center'
	| 'end'
	| 'space-between'
	| 'space-around';
export const flexGapMapping = {
	'0': '0',
	s: '--gap-s',
	m: '--gap-m',
	l: '--gap-l',
	x2: '--gap-x2',
	x3: '--gap-x3',
	x4: '--gap-x4',
	x5: '--gap-x5',
	x6: '--gap-x6',
	x7: '--gap-x7',
	x8: '--gap-x8',
	x9: '--gap-x9',
	x10: '--gap-x10',
	x11: '--gap-x11',
	x12: '--gap-x12',
} as const;

export type Gap = keyof typeof flexGapMapping;

export type HTMLTag = keyof JSX.IntrinsicElements;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AsType = HTMLTag | JSXElementConstructor<any>;

export type FlexProps<T extends AsType = 'div'> = {
	children?: React.ReactNode;
	className?: string;
	direction?: Direction;
	align?: Align;
	justify?: Justify;
	gap?: Gap;
	as?: AsType;
} & (T extends HTMLTag
	? JSX.IntrinsicElements[T]
	: T extends JSXElementConstructor<infer P>
	? P
	: never);
